import { connect } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { addCartItem } from 'redux/cart/actions';

const CoolPack = (props) => {
  const { cart, settings } = props;
  if (!cart) {
    return null;
  }
  const doesExist = cart.items.find((item) => item.sku === 'ICEPACKW');
  if (doesExist) {
    return null;
  }
  const itemCount = cart.items.reduce(
    (total, item) => total + item.quantity,
    0
  );
  const packsNeeded = Math.ceil(itemCount / 12);

  const handleAddCoolPack = (e) => {
    e.preventDefault();
    const item = {
      quantity: packsNeeded,
      sku: 'ICEPACKW'
    };
    const analytics = {
      viewType: 'CoolPack'
    };
    props.addCartItem(item, analytics);
  };
  if (cart.shipTo?.countryCode !== 'US') {
    return null;
  }
  return (
    <div className="c7-checkout__cool-pack">
      <strong>
        Cool Pack ~ {currencyFormat(packsNeeded * 1500, settings)}
      </strong>
      <br />
      Attention: To avoid heat damage to your wine, add a Cool Pack to your
      order if temperatures exceed 80 degrees in your delivery area. Cool Packs
      last 24-48 hours and we suggest that you upgrade shipping to 2-Day Air for
      optimum experience. Wine shipped without a Cool Pack will not be replaced.{' '}
      <button
        className="c7-button-small"
        type="button"
        onClick={handleAddCoolPack}
      >
        Add to order
      </button>
    </div>
  );
};

export default connect(null, { addCartItem })(CoolPack);
